// import React from "react";
import "./EducationTwoBlog.scss";

const EducationTwoBlog = () => {
  return (
    <section className="et-blog sect_padding">
      <div className="container">
        <div className="sect_header">
          <span className="sect_badge">BLOGS</span>
          <h3 className="sect_title d-flex justify-content-between">
            <div className="h3_inner">
              MOST POPULAR{" "}
              <span className="relative">
                POST
                <span className="title-shape">
                  <svg
                    width="150"
                    height="65"
                    viewBox="0 0 168 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="highligt_text"
                  >
                    <path
                      d="M73.3761 8.49147C78.4841 6.01353 82.5722 4.25154 88.8933 3.3035C94.2064 2.50664 99.6305 2.0701 104.981 1.94026C120.426 1.56549 135.132 4.90121 146.506 9.70405C158.628 14.8228 166.725 22.5638 166.074 31.6501C165.291 42.5779 151.346 51.7039 133.508 56.8189C110.253 63.4874 81.7065 63.8025 58.5605 60.8285C37.5033 58.123 11.6304 51.7165 3.58132 40.0216C-3.43085 29.8337 12.0728 18.1578 27.544 11.645C40.3656 6.24763 55.7082 2.98328 70.8043 4.08403C81.9391 4.89596 93.2164 6.87822 102.462 9.99561C112.874 13.5066 120.141 18.5932 127.862 23.6332"
                      stroke="var(--click-color)"
                      strokeWidth="3"
                      strokeLinecap="round"
                    ></path>
                  </svg>
                </span>
              </span>
            </div>
            <div className="theme_btn btn_fill with_icon">
              All Blog Post
              <span className="material-symbols-outlined">arrow_right_alt</span>
            </div>
          </h3>
        </div>

        <div className="et_blog_card">
          <div className="blog_card_single">
            <div className="img_area">
              <img src="./assets/img/educationtwo/course_one.jpg" alt="" />
            </div>
            <div className="content_area">
              <div className="other_info">
                <div className="oi_single">
                  <img src="./assets/img/educationtwo/icons/bg-cl.png" alt="" />
                  <span className="text">13 oct 2021</span>
                </div>
                <div className="oi_single">
                  <img src="./assets/img/educationtwo/icons/bg-cm.png" alt="" />
                  <span className="text">Comments</span>
                </div>
              </div>
              <h4 className="title">
                Angad's life revolves around animals, wild life, aquatic life
                and the planet that we live on. He is conscious about saving
              </h4>
              <a href="#" className="read-more-btn">
                Read More
                <span className="material-symbols-outlined">arrow_forward</span>
              </a>
            </div>
          </div>
          <div className="blog_card_single">
            <div className="img_area">
              <img src="./assets/img/educationtwo/course_one.jpg" alt="" />
            </div>
            <div className="content_area">
              <div className="other_info">
                <div className="oi_single">
                  <img src="./assets/img/educationtwo/icons/bg-cl.png" alt="" />
                  <span className="text">19 oct 2021</span>
                </div>
                <div className="oi_single">
                  <img src="./assets/img/educationtwo/icons/bg-cm.png" alt="" />
                  <span className="text">Comments</span>
                </div>
              </div>
              <h4 className="title">
                Music enlightens the spirit by sprouting the idea of
                self-discovery and broadening horizons. Children from a very
                young age
              </h4>
              <a href="#" className="read-more-btn">
                Read More
                <span className="material-symbols-outlined">arrow_forward</span>
              </a>
            </div>
          </div>
          <div className="blog_card_single">
            <div className="img_area">
              <img src="./assets/img/educationtwo/course_one.jpg" alt="" />
            </div>
            <div className="content_area">
              <div className="other_info">
                <div className="oi_single">
                  <img src="./assets/img/educationtwo/icons/bg-cl.png" alt="" />
                  <span className="text">7 oct 2023</span>
                </div>
                <div className="oi_single">
                  <img src="./assets/img/educationtwo/icons/bg-cm.png" alt="" />
                  <span className="text">Comments</span>
                </div>
              </div>
              <h4 className="title">
                TutorTot Media Partner with AIESEC in Chandigarh for GLOBAL
                GOALS RUN 2021 AIESEC Chandigarh is back with it's
              </h4>
              <a href="#" className="read-more-btn">
                Read More
                <span className="material-symbols-outlined">arrow_forward</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationTwoBlog;
